import React, { useState, useEffect } from 'react'
import { MaxHitChart } from './MaxHitChart'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { SearchCriteria, SearchCriteriaParams } from '@/pages/communal/statistics/components/common/searchCriteria'
import { mapBuckets } from '../common/labels'
import { HelpPopupButton } from '@/popups/helppopup/help'
import { formatDate } from '@/common/time'
import { MachineType } from '@/services/model/machine'
import { StaticPaginatedTable, StaticPaginatedTableState } from '@/components/search/StaticPaginatedTable'
import { MachineName } from '@/components/machine'
import { HitText } from '@/components/hit/HitText'

type MaxHitPopupProps = {
  services: Services
  session: CurrentSession
  criteria: SearchCriteria
  bucketFor: Date
  goToUserPage: (userId: string) => void
  goToMachinePage: (machineId: string) => void
  onClose: () => void
}

interface Machine {
  id: string
  imei: string
  internalNumber: string
  type: MachineType
}

interface User {
  id: string
  username: string
}

interface MachineHit {
  imei: string
  time: string
  hitX: number
  hitY: number
  hitZ: number
  maxHit: number
  machine: Machine
  user: User
}

export const MaxHitPopupBody = ({ services, session, criteria, bucketFor, goToUserPage, goToMachinePage, onClose }: MaxHitPopupProps) => {
  const translates = useTranslations(services, session)
  const [response, setResponse] = useState<any | undefined>()
  const [listState, setListState] = useState<StaticPaginatedTableState>({
    pageNumber: 1,
    pageSize: 10
  })

  useEffect(() => {
    setResponse(undefined)
    services.session
      .fetchWithToken(`/api/communal/statistics/machines/bucket/hits?bucketFor=${bucketFor.toISOString()}&${SearchCriteriaParams(criteria)}`)
      .then((r) => r.json())
      .then((data) => {
        setResponse(data)
        setListState({
          pageNumber: 1,
          pageSize: 10
        })
      })
  }, [services.session, criteria])

  if (translates === undefined || !response) {
    return <div className='spinner'></div>
  }

  return (
    <div>
      <h3>{formatDate(new Date(bucketFor))}</h3>

      <StaticPaginatedTable<MachineHit>
        data={response}
        parentState={listState}
        setParentState={setListState}
        header={() => <>
          <div className='hcol'>{translates.for('elements.table.maxhitpop.machine')}</div>
          <div className='hcol'>{translates.for('elements.table.maxhitpop.time')}</div>
          <div className='hcol'>{translates.for('elements.table.maxhitpop.max')}</div>
          <div className='hcol'>{translates.for('elements.table.maxhitpop.user')}</div>
        </>}
        row={(row) => {
          return <>
            <div className={`col`} onClick={() => {
              goToMachinePage(row.machine.id)
              onClose()
            }}>{row.machine ? <MachineName row={row.machine} /> : '-'}</div>
            <div className={`col`}>{row.time ? formatDate(new Date(row.time)) : '-'}</div>
            <div className={`col`}>
              <HitText value={row.maxHit}>{row.maxHit.toFixed(2)}</HitText>
              </div>
            <div className={`col`} onClick={() => {
              goToUserPage(row.user.id)
              onClose()
            }}>{row.user?.username || '-'}</div>
          </>
        }}
        translates={session.translates}
      />
    </div>
  )
}